// BF2020 Auth API List

const GET_PROD_BY_ORG = '/permissionManagment/permit/organization';
const SELECT_ORG = '/permissionManagment/permit/organization/user';

// 获取当前用户的所有产品信息列表
function fetchProducts(userId) {
  return this.$reqGet(`/adminAuth/auth/v5/user/${userId}/products`).then(res => res.data);
}

// 获取当前用户所选组织的产品ID列表
function getProductIDsByOrg(orgId) {
  return this.$reqGet(`${GET_PROD_BY_ORG}/${orgId}`).then(rsp => rsp.data.result);
}

// 获取当前用户的组织列表
function getSelectOrg(userid) {
  return this.$reqGet(`${SELECT_ORG}/${userid}`).then(rsp => rsp.data.result);
}

export default {
  getSelectOrg,
  getProductIDsByOrg,
  fetchProducts,
};



// WEBPACK FOOTER //
// ./src/api/auth.js